import React from 'react';
import InfoIcon from '../Icons/InfoIcon';
import VoxelTooltipLong from '../Tooltip/VoxelTooltipLong';
import VoxelText from '../Text/VoxelText';

export interface SearchCommandsInfoProps { }

export const SearchCommandsInfo: React.FC<SearchCommandsInfoProps> = ({ }) => {
  return (
    <div>
      <VoxelTooltipLong
        message={
          <div className="flex flex-col gap-2.5">
            <VoxelText variant="bread-medium" >
              Refine search
            </VoxelText>
            <div>
              <VoxelText variant="bread-medium" className='!text-[13px] !leading-relaxed'>
                Exact standalone match: <VoxelText variant='bread-normal' className='!text-[13px] !leading-relaxed' span>
                  Put a word or phrase inside quotes. For example, "tallest building".
                </VoxelText>
              </VoxelText>

            </div>
            <div>
              <VoxelText variant="bread-medium" className='!text-[13px] !leading-relaxed'>
                Exclude from search: <VoxelText variant='bread-normal' className='!text-[13px] !leading-relaxed' span>
                  Put - in front of a word you want to leave out. For example, jaguar speed -car.
                </VoxelText>
              </VoxelText>

            </div>
            <div>
              <VoxelText variant="bread-medium" className='!text-[13px] !leading-relaxed'>
                Use RegEx: <VoxelText variant='bread-normal' className='!text-[13px] !leading-relaxed' span>
                  Start the expression with ^ and end with $. Only support for one expression.
                </VoxelText>
              </VoxelText>

            </div>
          </div>
        }
      >
        <span>
          <InfoIcon />
        </span>
      </VoxelTooltipLong>
    </div>
  );
};

export default SearchCommandsInfo;
